export const ru = {
  plans: {
    title: 'Тарифы',
    subtitle: 'Тарифные планы и их лимиты. План по умолчанию получает каждый новый пользователь.',
    create: 'Создать план',
    edit: 'Изменить',
    editTitle: 'План «{name}»',
    createTitle: 'Новый тарифный план',
    empty: 'Планов пока нет',
    plan: 'План',
    limitsColumn: 'Лимиты',
    users: 'Пользователи',
    actions: 'Действия',
    isDefault: 'По умолчанию',
    archived: 'В архиве',
    makeDefault: 'Сделать по умолчанию',
    archive: 'В архив',
    unarchive: 'Из архива',
    allUnlimited: 'Без ограничений',
    readOnly: 'В демо-режиме тарифы только просматриваются.',
    form: {
      code: 'Код',
      codeHint: 'Латиница, цифры и дефис; после создания не меняется',
      name: 'Название',
      description: 'Описание',
      limitsTitle: 'Лимиты',
      unlimited: 'Без ограничения',
    },
    limits: {
      blogs: 'Блоги',
      editors: 'Редакторы',
      storageMb: 'Объём медиа, МБ',
      mediaPerDay: 'Загрузки медиа в сутки',
      postsPerDay: 'Посты в сутки',
      trafficGbPerMonth: 'Трафик медиа в месяц на блог, ГБ',
    },
    usageLabels: {
      blogs: 'Блоги',
      editors: 'Редакторы',
      storageMb: 'Объём медиа',
      mediaPerDay: 'Загрузки медиа за сутки',
      postsPerDay: 'Новые посты за сутки',
      trafficGbPerMonth: 'Трафик медиа за месяц, самый загруженный блог',
    },
    limitHints: {
      blogs: 'Блоги, созданные пользователем',
      editors: 'Владельцы и редакторы во всех его блогах, включая его самого; наблюдатели не считаются',
      storageMb: 'Медиа во всех его блогах вместе с JPEG-копиями и превью',
      mediaPerDay: 'За последние 24 часа',
      postsPerDay: 'За последние 24 часа, в том числе от ботов и из локальной копии',
      trafficGbPerMonth: 'У каждого блога свой счёт; меньший из этого и лимита платформы',
    },
    usage: {
      title: 'Тариф',
      plan: 'План «{name}»',
      unlimited: 'без ограничения',
      ofMax: '{used} из {max}',
      exhausted: 'исчерпан',
      notEnforced: 'Лимиты тарифов сейчас не применяются: израсходованное только считается.',
      defaultPlan: 'План по умолчанию: назначение не записано.',
      assignedAt: 'Назначен {at}',
      storageTitle: 'Объём медиа по блогам — с JPEG-копиями и превью',
      storageRow: '{name}: {used}',
      showFormats: 'по форматам',
      hideFormats: 'скрыть форматы',
      trafficTitle: 'Трафик медиа по блогам за месяц',
      trafficRow: '{name}: {used}',
      noBlogs: 'Блогов на этом тарифе пока нет.',
      changeHint: 'Сменить тариф может администратор платформы.',
    },
    user: {
      column: 'Тариф',
      open: 'Тариф',
      title: 'Тариф пользователя {login}',
      select: 'Тарифный план',
      save: 'Назначить',
      saved: 'План назначен.',
      archivedOption: '{name} (в архиве)',
    },
  },
};

export const en: typeof ru = {
  plans: {
    title: 'Plans',
    subtitle: 'Plans and their limits. Every new user gets the default plan.',
    create: 'Create plan',
    edit: 'Edit',
    editTitle: 'Plan "{name}"',
    createTitle: 'New plan',
    empty: 'No plans yet',
    plan: 'Plan',
    limitsColumn: 'Limits',
    users: 'Users',
    actions: 'Actions',
    isDefault: 'Default',
    archived: 'Archived',
    makeDefault: 'Make default',
    archive: 'Archive',
    unarchive: 'Unarchive',
    allUnlimited: 'Unlimited',
    readOnly: 'In demo mode plans are read-only.',
    form: {
      code: 'Code',
      codeHint: 'Latin letters, digits and hyphens; cannot be changed later',
      name: 'Name',
      description: 'Description',
      limitsTitle: 'Limits',
      unlimited: 'Unlimited',
    },
    limits: {
      blogs: 'Blogs',
      editors: 'Editors',
      storageMb: 'Media storage, MB',
      mediaPerDay: 'Media uploads per day',
      postsPerDay: 'Posts per day',
      trafficGbPerMonth: 'Media traffic per blog per month, GB',
    },
    usageLabels: {
      blogs: 'Blogs',
      editors: 'Editors',
      storageMb: 'Media storage',
      mediaPerDay: 'Media uploads in a day',
      postsPerDay: 'New posts in a day',
      trafficGbPerMonth: 'Media traffic this month, busiest blog',
    },
    limitHints: {
      blogs: 'Blogs created by the user',
      editors: 'Owners and editors across all their blogs, themselves included; viewers are free',
      storageMb: 'Media across all their blogs, with JPEG copies and previews',
      mediaPerDay: 'In the last 24 hours',
      postsPerDay: 'In the last 24 hours, bots and local copies included',
      trafficGbPerMonth: 'Each blog counts separately; the smaller of this and the platform limit applies',
    },
    usage: {
      title: 'Plan',
      plan: 'Plan "{name}"',
      unlimited: 'unlimited',
      ofMax: '{used} of {max}',
      exhausted: 'used up',
      notEnforced: 'Plan limits are not enforced right now: usage is only counted.',
      defaultPlan: 'Default plan: no assignment is recorded.',
      assignedAt: 'Assigned on {at}',
      storageTitle: 'Media volume by blog — with JPEG copies and previews',
      storageRow: '{name}: {used}',
      showFormats: 'by format',
      hideFormats: 'hide formats',
      trafficTitle: 'Media traffic by blog this month',
      trafficRow: '{name}: {used}',
      noBlogs: 'No blogs on this plan yet.',
      changeHint: 'A platform administrator can change your plan.',
    },
    user: {
      column: 'Plan',
      open: 'Plan',
      title: 'Plan of {login}',
      select: 'Plan',
      save: 'Assign',
      saved: 'The plan is assigned.',
      archivedOption: '{name} (archived)',
    },
  },
};
